import gql from 'graphql-tag';

export const reputationFragment = gql`
  fragment SingleReputation on Reputation {
    id
    comment
    evaluator {
      id
      name
      profileImageUrl
    }
    score
    updatedAt
  }
`;
